if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const hasSubscription = this.hasAttribute('data-has-subscription');
      const threshold = Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const remaining = threshold - cartTotal;
      const qualified = hasSubscription || remaining <= 0;
      const pct = hasSubscription ? 100 : Math.min(Math.round((cartTotal / threshold) * 100), 100);

      let message = '';
      if (qualified) {
        message = 'You\'ve unlocked a <strong>Free Recipe Ebook!</strong>';
      } else {
        message = 'Spend <strong>' + this._formatMoney(remaining, KROWN.settings.shop_money_format) + '</strong> more to unlock a <strong>Free Recipe Ebook!</strong>';
      }

      const bookSvg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="#003d29" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="#003d29" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="#fff"/><path d="M8 7h8M8 11h5" stroke="#003d29" stroke-width="1.5" stroke-linecap="round"/></svg>';

      this.innerHTML = `
        <div class="shipping-bar ${qualified ? 'shipping-bar--qualified' : ''}">
          <div class="shipping-bar__close-btn" aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
          <p class="shipping-bar__message">${message}</p>
          <div class="shipping-bar__track">
            <div class="shipping-bar__fill" style="width:0%"></div>
            <span class="shipping-bar__icon">${bookSvg}</span>
          </div>
          <p class="shipping-bar__label">Free Recipe Ebook!</p>
        </div>`;

      /* Animate the fill after a frame */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const fill = this.querySelector('.shipping-bar__fill');
          const icon = this.querySelector('.shipping-bar__icon');
          if (fill) fill.style.width = pct + '%';
          if (icon) icon.style.left = pct + '%';
        });
      });

      /* Confetti burst when qualified — skip on mobile and duplicate instances */
      if (qualified && window.innerWidth >= 768 && !this.hasAttribute('data-no-confetti')) {
        this._confetti();
      }

      /* Show/hide upsell products based on threshold */
      var upsellContainer = document.querySelector('[data-upsell-threshold]');
      if (upsellContainer) {
        upsellContainer.style.display = qualified ? 'none' : '';
      }

      /* Ebook auto-add is handled by the inline script in cart-form.liquid.
         Do NOT submit here — it causes duplicate submissions on mobile. */

      /* Close button — close the cart drawer if inside one */
      const closeBtn = this.querySelector('.shipping-bar__close-btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          const sidebar = this.closest('sidebar-drawer');
          if (sidebar) {
            const sidebarClose = sidebar.querySelector('[data-js-close]');
            if (sidebarClose) sidebarClose.click();
          } else {
            this.style.display = 'none';
          }
        });
      }

    }

    _confetti() {
      const bar = this.querySelector('.shipping-bar');
      if (!bar) return;
      const colors = ['#c9a84c', '#d4b85e', '#4CAF50', '#fff', '#FFD700', '#FF6B6B', '#36D399'];
      const count = 20;
      const container = document.createElement('div');
      container.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;pointer-events:none;z-index:10';
      bar.style.position = 'relative';

      var frag = document.createDocumentFragment();
      var pieces = [];
      for (var i = 0; i < count; i++) {
        var piece = document.createElement('div');
        var color = colors[Math.floor(Math.random() * colors.length)];
        var size = Math.random() * 8 + 4;
        var left = Math.random() * 100;
        var angle = (Math.random() - 0.5) * 120;
        var dist = Math.random() * 120 + 60;
        var dur = Math.random() * 800 + 800;
        var shape = Math.random() > 0.5 ? '50%' : '0';
        piece.style.cssText = 'position:absolute;bottom:50%;left:' + left + '%;width:' + size + 'px;height:' + size + 'px;background:' + color + ';border-radius:' + shape + ';opacity:1;will-change:transform,opacity;transform:translate3d(0,0,0) rotate(0deg);transition:transform ' + dur + 'ms cubic-bezier(0.25,0.46,0.45,0.94),opacity ' + dur + 'ms ease;pointer-events:none;';
        frag.appendChild(piece);
        pieces.push({ el: piece, angle: angle, dist: dist });
      }
      container.appendChild(frag);
      bar.appendChild(container);

      /* Single rAF to trigger all transitions at once */
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          for (var j = 0; j < pieces.length; j++) {
            var p = pieces[j];
            p.el.style.transform = 'translate3d(' + (Math.sin(p.angle * Math.PI / 180) * p.dist) + 'px,' + (-Math.abs(Math.cos(p.angle * Math.PI / 180)) * p.dist - 20) + 'px,0) rotate(' + (Math.random() * 360) + 'deg)';
            p.el.style.opacity = '0';
          }
        });
      });

      setTimeout(function() { container.remove(); }, 2000);
    }

    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);

		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}